import React from 'react';
import PropTypes from 'prop-types';
import { HelmetDatoCms } from 'gatsby-source-datocms';

import Navbar from '../components/navbar';

import './index.css';

const Layout = ({ children, data }) => {
  const { datoCmsSite, datoCmsPersonalInformation } = data;

  return (
    <div className="site-wrapper">
      <HelmetDatoCms favicon={datoCmsSite.faviconMetaTags}>
        <title>{datoCmsSite.globalSeo.siteName}</title>
        <html lang={datoCmsSite.locale} amp />
        <meta
          name="description"
          content={datoCmsSite.globalSeo.fallbackSeo.description}
        />
        <meta property="og:url" content="https://lesplumes.fr" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={datoCmsSite.globalSeo.siteName} />
        <meta
          property="og:description"
          content={datoCmsSite.globalSeo.fallbackSeo.description}
        />
        <meta
          property="og:image"
          content={datoCmsSite.globalSeo.fallbackSeo.image.url}
        />
        <meta
          property="og:image:width"
          content={datoCmsSite.globalSeo.fallbackSeo.image.width}
        />
        <meta
          property="og:image:height"
          content={datoCmsSite.globalSeo.fallbackSeo.image.height}
        />
      </HelmetDatoCms>

      <Navbar {...datoCmsPersonalInformation} />
      <main>{children()}</main>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.func
};

export default Layout;

export const query = graphql`
  query LayoutQuery {
    datoCmsSite {
      globalSeo {
        siteName
        fallbackSeo {
          description
          image {
            url
            height
            width
          }
        }
      }
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    datoCmsPersonalInformation {
      ...NavbarFragment
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js